<h1 mat-dialog-title>Plans sent to Ease<img height="42px" width="42px" src="../../assets/images/paper-plane.png"></h1>
<mat-dialog-content>
    <div class="modal-top">
        <div>
            <p class="modal-description">
                BenefitMall is syncing your New Group plans, rates, and census information to Ease.<br/>
                You will receive an email when data has successfully synced. Once synced, you will login to your Ease account to complete enrollments.
                <br /> <b>CONTINUE</b> and return to Agency Workspace.
            </p>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions>
    <button mat-raised-button color="warn" (click)="onSyncClick()" cdkFocusInitial>CONTINUE</button>
</div>
